<script>
  /**@type {({ hidden?: boolean, label: string } & Object<string, any> )?} */
  export let link
</script>

<article class="blurb">
  <figure class="figure">
    <slot />
  </figure>

  <div class="body">
    <slot name="content" />
    {#if link}
      {@const { label, ...attrs } = link}
      <svelte:element
        this={link.href ? 'a' : 'button'}
        role={link.href ? 'link' : 'button'}
        class="link"
        on:click
        {...attrs}>
        <span class="u-hidden">{label}</span>
      </svelte:element>
    {/if}
  </div>
</article>

<style>
  .blurb {
    display: flex;
    align-items: flex-start;
    position: relative;
  }

  .figure {
    flex: 0 0 auto;
    width: 40%;
    max-width: 5.5rem;
    max-height: 5.5rem;
    border-radius: var(--border-radius-md);
    margin-right: 1.25rem;
    position: relative;
    overflow: hidden;
  }

  @media (min-width: 1400px) {
    .figure {
      max-width: 9rem;
      max-height: 9rem;
      margin-right: 1.5rem;
    }
  }

  .figure::before {
    content: '';
    display: block;
    padding-top: 100%;
  }

  .figure :global(img) {
    object-fit: cover;
    min-width: 100%;
    min-height: 100%;
    max-height: 100%;
    width: auto;
    height: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .body {
    flex: 1 1 auto;
    color: rgb(var(--rgb-text));
    margin-top: 0.25em;
  }

  .link::after {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }
</style>
